/// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
//10.37.54.148:8090/",
// localhost:9090
//192.168.1.3:8080
export const environment = {

  production: true,
  baseUrl: window.location.origin,
  apiEndPoint : '/TEDSServices/',
  uploadURL : window.location.origin + '/TEDSServices/'


  //production: false,
  // baseUrl: "http://localhost:8080/",
  // uploadURL : 'http://localhost:8080/TEDSServices/',
  // apiEndPoint : "http://localhost:8080/TEDSServices/"

  //baseUrl: "https://" + "//" + window.location.hostname + ":6443",
  //uploadURL : "https://" + window.location.hostname + ":6443" + '/TEDSServices/',
  //apiEndPoint : "https://" + window.location.hostname + ":6443" + '/TEDSServices/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts